module.exports = __webpack_public_path__ + "media/images/pepsi-north-new-f8a57053128314d62b0c6acc02fc24ff.png";